import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { API_STATES } from '../api';
import { evalWithWebDesigner, fetchByCategoryParam, resetStatus } from '../redux/slices/categoryDataSlice';
import { resetRowsPerPage, resetSortOrder } from '../components/ProductsTable/productsTableSlice';
import { useLocation } from 'react-router-dom';
import { setInputParameters } from '../redux/slices/wdValidatorSlice';
import queryString from 'query-string';

export const useFetchCategoryData = categoryApiParam => {
	let location = useLocation();
	const dispatch = useDispatch();
	const status = useSelector(state => state.categoryData.status);

	useEffect(() => {
		if (location.pathname.includes('/wdValidated')) {
			const search = queryString.parse(location.search);
			dispatch(evalWithWebDesigner(search));
			dispatch(setInputParameters(search));
		} else {
			dispatch(fetchByCategoryParam(categoryApiParam));
		}

		return () => {
			dispatch(resetStatus());
			dispatch(resetRowsPerPage());
			dispatch(resetSortOrder());
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [evalWithWebDesigner, fetchByCategoryParam, dispatch]);

	return { status };
};
